import { render, staticRenderFns } from "./AppContactBusinessCardDlg.vue?vue&type=template&id=0c0ab9e4&scoped=true"
import script from "./AppContactBusinessCardDlg.vue?vue&type=script&lang=js"
export * from "./AppContactBusinessCardDlg.vue?vue&type=script&lang=js"
import style0 from "./AppContactBusinessCardDlg.vue?vue&type=style&index=0&id=0c0ab9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ab9e4",
  null
  
)

export default component.exports